<template>
    <div class="">
        <v-dialog v-model="showDialog" persistent max-width="500">
            <v-card>
                <div class="pa-6">
                    <div class="text-center mb-6">
                        <v-icon color="red" size="100">
                            mdi-alert
                        </v-icon>
                    </div>
                    <h4 class="text-center font-weight-bold ">
                        Přístup zablokován
                    </h4>

                    <div class="my-4">
                        Váš přístup na tuto stránku byl
                        <strong>dočasně zablokován</strong> z důvodu
                        <strong>nesplnění podmínek</strong> stanovených
                        <strong
                            >Stavovským <br >
                            předpisem č. 16</strong
                        >.
                    </div>
                    <div class="my-4">
                        Pro více informací o důvodech blokace a možnostech
                        <strong>odblokování účtu</strong> se prosím obraťte na
                        Českou lékařskou komoru:
                    </div>
                    <div class="my-6">
                        <div class="mb-2">
                            Pavla Hašková
                        </div>
                        <div class="mb-2">
                            E-mail:
                            <a href="mailto:vzdelavani@clkcr.cz">
                                vzdelavani@clkcr.cz
                            </a>
                        </div>
                        <div>
                            Telefon: 234 760 710
                        </div>
                    </div>
                    <div class="mt-4">
                        Děkujeme za pochopení.
                    </div>

                    <div class="mt-12">
                        <v-btn
                            block
                            color="primary"
                            @click="redirectToCheckActivitie()"
                        >
                            {{
                                $_isMobile
                                    ? 'Zkontrolovat aktivity'
                                    : 'Zkontrolovat problematické aktivity'
                            }}
                        </v-btn>
                    </div>
                </div>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import cssBreakpointsMixin from '../mixins/cssBreakpointsMixin';

export default {
    name: 'ModalPageBlocked',
    mixins: [cssBreakpointsMixin],
    data() {
        return {
            blockedRoutesPath: [
                '/aktivity/nova',
                '/portaly',
                '/placene-sluzby',
                '/zadosti/portaly/novy',
                '/placene-sluzby/topovat-aktivitu'
            ]
        };
    },

    computed: {
        showDialog() {
            if (this.blockedRoutesPath.includes(this.$route.path)) {
                return true;
            }
            return false;
        }
    },

    methods: {
        redirectToCheckActivitie() {
            if (this.$route.name === 'aktivity') {
                // If we're already on the 'aktivity' route, reload with query directly.
                const query = '?status=&showWithMissingAttendance=true';
                window.location.replace(`/aktivity/${query}`);
                return;
            }

            // If we're not on 'aktivity' route, navigate with router and reload after.
            this.$router.push({
                name: 'aktivity',
                query: { showWithMissingAttendance: true, status: '' }
            });
        }
    }
};
</script>

<style lang="scss" scoped></style>
